import { AbstractCommand } from 'src/models/command';

class CreateDocumentVersionCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Document_CreateDocumentVersion';

	public constructor(
		aggregateId: string,
		aggregateVersion: number,
		documentFileName: string,
		documentFileType: string,
		documentFileSize: number,
		documentFileData: string
	) {
		super();
		this.parameters = {
			aggregateId: aggregateId,
			aggregateVersion: aggregateVersion,
			documentFileData: documentFileData,
			documentFileName: documentFileName,
			documentFileSize: documentFileSize,
			documentFileType: documentFileType,
		};
	}
}

export { CreateDocumentVersionCommand };
